import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { ServerResourcesPathPipe } from "src/app/pipe/serverresourcespath.pipe";
import { PageObjectVideo } from "src/app/models/pageobjectvideo";
import { Exam } from "src/app/models/exam";

@Component({
  selector: "hkt-pageobjectvideo",
  templateUrl: "./pageobjectvideo.component.html",
  styleUrls: ["./pageobjectvideo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageObjectVideoComponent implements OnChanges {
  @Input("obj") obj: PageObjectVideo;
  @Input("mode") mode: string;
  // Following inputs are only used for change detection. The component only updated when the input changes
  @Input("video") video: string;
  @Input("border") border: boolean;

  exam: Exam;
  examSubscription: Subscription;
  videoUrl: any;

  constructor(
    private examService: ExamService,
    private serverResourcesPathPipe: ServerResourcesPathPipe,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.exam = this.examService.currentExam;
    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => (this.exam = exam));
    this.videoUrl = null;
  }

  ngOnDestroy(): void {
    this.examSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.video) {
      this.updateSourceUrl();
    }
  }

  private updateSourceUrl(): void {
    if (!this.exam || !this.exam.library) {
      setTimeout(() => this.updateSourceUrl(), 100);
      return;
    }

    let video = this.exam.library.getVideo(this.obj.video);
    let ret = null;

    if (video) {
      let src = video.source;
      if (this.mode == "edit") {
        src += "#t=0.5";
      }
      ret = this.serverResourcesPathPipe.transform(src, Config.SERVER_UPLOADFOLDER);
    }

    this.videoUrl = ret;
    this.changeDetectorRef.markForCheck();
  }
}
